export const texts = {
  projectManager: { de: 'Projektmanager', en: 'Project manager' },
  moderator: { de: 'Moderator', en: 'Moderator' },
  decider: { de: 'Entscheider', en: 'Decision-maker' },
  deciderModerator: { de: 'Entscheider & Moderator', en: 'Decision-maker & moderator' },
  notRegistered: { de: 'Nicht registriert', en: 'Not registered' },
  removeParticipant: { de: 'Teilnehmer entfernen', en: 'Remove participant' }
};
